import { defineMessages } from 'react-intl';

export default defineMessages({
  cookieSettingsButtonTooltip: {
    defaultMessage: 'Change your cookie settings',
    description: 'Cookie settings button tooltip',
    id: 'cookieSettingsButton.tooltip',
  },
});
